import {useState, useCallback} from 'react'
import {Bag} from 'modules/reports/contexts/bag'

function useBag<T>(): Bag<T> {
  const [items, setItems] = useState<T[]>([])

  const includes = function(item: T) {
    return items.indexOf(item) !== -1
  }

  const add = useCallback(function(item: T) {
    setItems(items => {
      if (items.indexOf(item) !== -1) return items
      return [...items, item]
    })
  }, [])

  const remove = useCallback(function(item: T) {
    setItems(items => items.filter(iteratorItem => item !== iteratorItem))
  }, [])

  const clear = useCallback(function() {
    setItems([])
  }, [])

  return {items, includes, add, remove, clear}
}

export default useBag
